export default "__VITE_ASSET__d95e7273__"